
  import moment from 'moment'
  import { defineComponent, onMounted, reactive, ref, onActivated, watch, toRefs } from 'vue'
  import { queryApplyInfo, approveApply, wechatLogin } from '@/apis/comm/api'
  import { useRoute, useRouter } from 'vue-router'
  import { showSuccessToast, showToast, showLoadingToast } from 'vant'
  import router from '@/router'
  import _ from 'lodash'
  import axios from '@/apis/config'

  export default defineComponent({
    name: 'applyfor',
    setup() {
      const route = useRoute()
      onMounted(async () => {
        info.shdate = moment().format('YYYY-MM-DD')
        const query = route.query
        if (query && query.id) {
          info.id = query.id
          if (query.token) info.token = query.token
          if (query.uid) {
            const { data } = await wechatLogin({ uid: query.uid })
            info.token = data.data['Authorization']
          }
          info.sdWorkHandleId = query.sdWorkHandleId
          info.getApplyInfo()
          info.getApprovalBase()
        }
        if (query && query.view) {
          info.view = true
          info.getApprovalInfo()
        }
      })
      const formRef = ref(null)
      const info = reactive({
        id: '' as any,
        token: '' as any,
        sdWorkHandleId: '' as any,
        view: false,
        form: {},
        shr: '',
        shdate: '',
        idea: undefined as any,
        applyInfo: {} as any,
        dataList: [],
        remark: '',
        url: (window as any).VUE_APP_BASE_URL,
        submit_loading: false,

        async getApplyInfo() {
          const { data } = await queryApplyInfo(info.id)
          if (data.code == 200) {
            data.data.visiStartTime = data.data.visiStartTime.slice(0, 10)
            info.applyInfo = data.data
            info.dataList = data.data.carsRecordList
            info.view = data.data.approvalState == '5' ? false : true
          }
        },

        async submit(val: any) {
          let data = {
            approvalOpinion: info.remark, //意见
            idea: val
          }
          if (val == 2 && !data.approvalOpinion) {
            data.approvalOpinion = '不同意'
          }
          if (val == 1 && !data.approvalOpinion) {
            data.approvalOpinion = '同意'
          }
          const loading = showLoadingToast({
            message: '提交中...',
            forbidClick: true
          })
          let query = _.assign(data, info.form)
          axios
            .post(info.url + '/task/formDataSave', query, {
              headers: {
                Authorization: info.token
              }
            })
            .then(res => {
              loading.close()
              if (res.data.code == 200) {
                showSuccessToast('审批成功')
                info.view = true
                router.go(-1)
              } else {
                showToast(res.data.msg)
              }
            })
        },
        async getApprovalBase() {
          axios
            .get(info.url + '/spWorkHandle/getSpWorkHandleById/' + info.sdWorkHandleId, {
              headers: {
                Authorization: info.token
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                info.form = res.data.data
                info.shr = res.data.data.handler
              }
            })
        },
        async getApprovalInfo() {
          axios
            .get(info.url + '/sdApprovalInfo/selectCaApprovalInfoByProWorkHandelId/' + info.sdWorkHandleId, {
              headers: {
                Authorization: info.token
              }
            })
            .then(res => {
              if (res.data.code == 200 && res.data.data) {
                info.remark = res.data.data.approvalOpinion
                info.shdate = res.data.data.approvalTime.slice(0, 10)
                info.shr = res.data.data.approvalName
                info.idea = res.data.data.idea
              }
            })
        }
      })
      return { info, formRef }
    }
  })
